import { useState, useEffect } from 'react'
import { getProvidentStatusAPI } from '../services/provident-fund'

function UsePVDStatus() {
  const [data, setData] = useState([])
  useEffect(() => {
    const getData = async () => {
      const resp = await getProvidentStatusAPI()
      if (!resp) return

      const newData = resp.result.map((d, i) => ({
        value: d.id,
        label: d.status_name
      }))

      setData(newData)
    }
    getData()
  }, [])

  return data
}

export default UsePVDStatus
